import React from 'react'
import { Title } from '@/components/quiz/Title'
import { Description } from '@/components/quiz/Description'

export const RiskFree = () => {
  return (
    <div className="bg-[#D7A21314] rounded-3xl mb-5 py-14 px-10">
      <img
        className="max-w-[140px] w-full mx-auto -mb-7"
        src="/quiz/images/satisfaction.png"
        alt="vector"
      />
      <Title data={{ title: 'Try it risk-free', isSmall: true }} />
      <div className="mt-5"></div>
      <Description
        data={{
          description:
            'We’re confident you’ll see real results in 4 weeks. If not, and you’ve followed the plan,\n' +
            '        we’ll give you a full refund.',
        }}
      />

      <ul className="flex mt-7 justify-center gap-6">
        <li>
          <a
            className="text-[#C68800] font-semibold text-[14px] hover:underline"
            href="/terms-of-use-quiz"
          >
            Terms
          </a>
        </li>
        <li>
          <a
            className="text-[#C68800] font-semibold text-[14px] hover:underline"
            href="/privacy-policy-quiz"
          >
            Privacy
          </a>
        </li>
      </ul>
    </div>
  )
}
